import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_CLIENTS, UPDATE_CLIENTS_SUCCESS, UPDATE_CLIENTS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateClient({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/clients`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Client updated successfully`);
      yield put({
        type: UPDATE_CLIENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: UPDATE_CLIENTS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CLIENTS_ERROR, payload: error });
  }
}

export function* watchUpdateClient() {
  yield takeEvery(UPDATE_CLIENTS, updateClient);
}

function* updateClientSaga() {
  yield all([fork(watchUpdateClient)]);
}

export default updateClientSaga;
